import React from "react";
import { Button, Card, Progress, Typography } from "@arco-design/web-react";
import { IconCheckCircleFill, IconRight } from "@arco-design/web-react/icon";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { FetchApi } from "../Api/AuthenticatedApi";
import { gettingStartedSteps, allDone, completedCount } from "./gettingStarted";

const { Title, Text } = Typography;

// First-run checklist on Home: verify a sender, add contacts, create a send.
// Hides itself once the org is set up (all steps done).
export default function GettingStartedCard({ metrics }) {
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [hasSender, setHasSender] = React.useState(null);

  React.useEffect(() => {
    FetchApi(
      getAccessTokenSilently,
      "/api/settings/confirmed-sender-emails/",
      (data) => setHasSender(Array.isArray(data) && data.length > 0),
      () => {},
      () => setHasSender(false)
    );
  }, [getAccessTokenSilently]);

  const steps = gettingStartedSteps({
    hasVerifiedSender: hasSender,
    contacts: metrics && metrics.contacts,
    campaigns: metrics && metrics.campaigns,
    broadcasts: metrics && metrics.broadcasts,
  });

  // Don't flash before the sender check resolves, and hide once fully set up.
  if (hasSender === null || allDone(steps)) {
    return null;
  }

  const done = completedCount(steps);
  return (
    <Card style={{ marginBottom: 24, borderRadius: 8 }}>
      <Title heading={6} style={{ marginTop: 0, marginBottom: 4 }}>
        Getting started
      </Title>
      <Text type="secondary">{done} of {steps.length} complete</Text>
      <Progress
        percent={Math.round((done / steps.length) * 100)}
        style={{ margin: "12px 0 4px" }}
        showText={false}
      />
      {steps.map((step) => (
        <div key={step.key} style={{ display: "flex", alignItems: "center", padding: "10px 0" }}>
          <IconCheckCircleFill
            style={{ fontSize: 18, marginRight: 10, color: step.done ? "rgb(var(--green-6))" : "var(--color-fill-3)" }}
          />
          <Text
            delete={step.done}
            style={{ flexGrow: 1, color: step.done ? "var(--color-text-3)" : "var(--color-text-1)" }}
          >
            {step.label}
          </Text>
          {!step.done && (
            <Button size="small" type="text" onClick={() => navigate(step.path)}>
              {step.cta} <IconRight />
            </Button>
          )}
        </div>
      ))}
    </Card>
  );
}
